<template>
  <cumulus-edit-form
    ref="form"
    :icon="icon"
    :title="title"
    :title-ext="user_name"
    :new-item="new_item"
    :can-delete="false"
    @escape="escape"
    @save="save"
  >
    <template v-slot:editform>
      <edit-form
        :pilot-info="edited_item.pilot_info"
      />
      <material-card
        color="accent"
        icon="$organizations"
        :title="$t('user_organization_data')"
        class="mb-6 pb-2 card-block"
      >
        <edit-user-organization
          :user-organization="edited_item.user_organization"
        />
      </material-card>
    </template>
  </cumulus-edit-form>
</template>

<script>
  // Utilities
  import { call } from 'vuex-pathify'
  import EditUserOrganization from '@/layouts/default/edit/UserOrganization'

  export default {
    name: 'UserPilotInfoEdit',
    components: {
      EditUserOrganization,
      EditForm: () => import('@/layouts/default/edit/UserPilotInfo'),
    },
    data: function () {
      return {
        icon: '$user',
        title: 'pilot_datas',
        edited_item_id: -1,
        edited_item: {},
        user_name: '',
        loading: false,
        prevRoute: '',
        saved: false,
      }
    },
    computed: {
      new_item () { return this.edited_item_id === -1 },
    },
    mounted () {
      this.getName()
      this.fetch()
    },
    methods: {
      fetchEditedItem: call('user/fetchPilotInfo'),
      updateEditedItem: call('user/updatePilotInfo'),
      fetchDatasource: call('datasource/fetchDatasource'),
      async fetch () {
        this.edited_item_id = parseInt(this.$route.params.id)
        this.loading = true
        if (!this.new_item) {
          this.fetchEditedItem({ id: this.edited_item_id }).then(response => {
            this.edited_item = response
            this.loading = false
          })
        } else {
          this.edited_item = {
            roles: ['pilot'],
          }
        }
      },
      async save () {
        this.loading = true
        await this.updateEditedItem(
          this.edited_item,
        ).then(response => {
          this.escape()
        }).catch(e => {
          this.loading = false
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      escape () {
        this.$router.push(this.prevRoute.path).catch(() => {})
      },
      getName () {
        this.fetchDatasource({ sourceType: 'users' }).then(response => {
          response = response.filter(f => f.id === this.edited_item_id)
          this.user_name = response[0].name
        })
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }
</script>
